import { apiGet, apiPost, apiDelete } from './client';

export interface AiChatMessage {
  role: 'user' | 'assistant';
  text: string;
}

export interface AiUsageData {
  usedMessages: number;
  maxMessages: number;
  month?: string;
  isPremium?: boolean;
  aiCredits?: number;
  outOfQuota?: boolean;
}

export interface AiChatResponse {
  reply: string;
  suggestedQuestions?: string[];
  usage?: AiUsageData;
  timestamp?: string;
}

export async function sendAiChatMessage(
  message: string,
  history: AiChatMessage[] = []
): Promise<AiChatResponse> {
  return apiPost<AiChatResponse>('/ai/chat', { message, history });
}

export async function getAiUsage(): Promise<AiUsageData> {
  return apiGet<AiUsageData>('/ai/usage');
}

export async function simulateUpgrade(premium: boolean): Promise<{ isPremium: boolean }> {
  return apiPost<{ isPremium: boolean }>('/student/upgrade', { premium });
}

export async function simulateAddCredits(amount: number): Promise<{ success: boolean; aiCredits: number }> {
  return apiPost<{ success: boolean; aiCredits: number }>('/student/add-credits', { amount });
}

export async function simulateResetUsage(): Promise<{ success: boolean }> {
  return apiPost<{ success: boolean }>('/student/reset-ai-usage');
}

export interface RazorpayCreditsOrderResponse {
  order_id: string;
  amount: number;
  currency: string;
  amountCredits: number;
  key_id: string;
}

export async function createRazorpayCreditsOrder(amount: number): Promise<RazorpayCreditsOrderResponse> {
  return apiPost<RazorpayCreditsOrderResponse>('/student/razorpay/create-credits-order', { amount });
}

export async function verifyRazorpayCreditsPayment(payload: {
  razorpay_payment_id: string;
  razorpay_order_id: string;
  razorpay_signature: string;
  amount: number;
}): Promise<{ success: boolean; aiCredits: number; paymentId: number }> {
  return apiPost<{ success: boolean; aiCredits: number; paymentId: number }>('/student/razorpay/verify-credits-payment', payload);
}

export interface AiChatSession {
  id: string;
  title: string;
  updatedAt: string;
  messages: AiChatMessage[];
}

export async function getAiSessions(): Promise<AiChatSession[]> {
  return apiGet<AiChatSession[]>('/ai/sessions');
}

export async function saveAiSession(session: {
  id: string;
  title: string;
  messages: AiChatMessage[];
  updatedAt?: string;
}): Promise<AiChatSession> {
  return apiPost<AiChatSession>('/ai/sessions', session);
}

export async function deleteAiSession(id: string): Promise<{ success: boolean }> {
  return apiDelete<{ success: boolean }>(`/ai/sessions/${id}`);
}
